/**
 * Optional remaps for mistaken or obsolete keys.
 * Prefer breadcrumb keys (`common.*` / `modules.*` / `core.*`) in templates.
 */
export const EXPERIENCE_I18N_KEY_ALIASES: Readonly<Record<string, string>> = {};

export function resolveExperienceI18nKey(key: string): string {
    return EXPERIENCE_I18N_KEY_ALIASES[key] ?? key;
}
